<template>
  <div class="mandati">
    <gnetHeader></gnetHeader>

    <gnetTabBar
      v-bind:titoloapp="$store.getters.appname"
      v-bind:tabs="$store.state.tabs"
      v-bind:active_tab="$store.state.active_tab"
      v-on:click="changeTab($event)"
    />

    <div class="slds-grid">
      <div class="slds-col slds-size_2-of-3">

        <gnetRecordHeader
          v-bind:object="'account'"
          v-bind:title="'Lead '+record.Name"
          
          v-bind:fields="headlineFields"
          v-bind:actions="headlineActions"
          v-on:click="actionClick($event)"
        />

        <div class="slds-page-header">
          <div class="slds-page-header__row">
            <recordfields v-if="showRecord" v-bind:newcustomer="false"  v-bind:dati="dati" v-bind:readonly="true"></recordfields>      
          </div>
        </div>

      </div>
      <div class="slds-col slds-size_1-of-3">
        <gnetRecordHeader 
          v-bind:object="'task'" 
          v-bind:title="'Attività'" 
          v-bind:actions="timelineActions"
          v-on:click="actionClick($event)"
        />
        <gnetTimeline v-bind:records="timeline"> </gnetTimeline>
      </div>

    </div>

    <gnetActivity v-show="editTask" v-on:save="saveTask($event)" v-on:cancel="editTask=false" />

    <qualifica v-if="showQualifica" v-bind:newcustomer="true" v-bind:dati="dati" v-on:cancel="showQualifica=false" v-on:change="setField($event)" v-on:submit="updateAccount" ></qualifica>
    <gnetSpinner v-bind:busy="busy"></gnetSpinner>

  </div>
</template>

<script>
// @ is an alias to /src
// import numeral from 'numeral'
import gnetHeader from '../components/header.vue'
import gnetTabBar from '../components/tabbar.vue'
import gnetRecordHeader from '../components/recordheader.vue'
import gnetTimeline from '../components/timeline.vue'
import gnetSpinner from '../components/spinner.vue'
import apiclient from '@/apiclient.js'
import gnetMixLib from '@/mixin.js'
import qualifica from '../components/qualifica.vue'
import recordfields from '../components/recordfields.vue'
import gnetActivity from '../components/activity.vue'
import moment from 'moment'

export default {
  name: 'Mandato',
  mixins: [gnetMixLib],
  components: {
    gnetHeader,
    gnetTabBar,
    gnetRecordHeader,
    gnetTimeline,
    gnetSpinner,
    qualifica,
    recordfields,
    gnetActivity
  },
  data: function() {
    return {
      busy: false,
      recordId:'',
      record: {},

      cols:[],
      records:[],

      editTask:false,

      fields:[],
      fieldsstring: '',
      headlineFields: [],
      headlineActions: [ {title:'Qualifica', name:'qualifica', symbol:'task'} ],
      timelineActions: [ {name:'newtask', symbol:'task', title:'Nuova Attività'}],
      sections:[],

      timeline: [],

      showRecord:false,

      showQualifica:false,
      dati: {
        Name:'',
        Codice_Subentro__c:'',
        Insegna__c:'',

        BillingStreet:'',
        BillingCity:'',
        BillingPostalcode:'',
        BillingState:'',

        Referente__c:'',
        Phone:'',
        Fax:'',
        Email__c:'',

        P_Iva__c:'',
        IBAN__c:'',
        Codice_Fatturazione_Elettronica__c:'',
        PEC__c:'',

        Spedire__c:'',
        ShippingStreet:'',
        ShippingCity:'',
        ShippingPostalcode:'',
        ShippingState:'',

        Referente_Consegne__c:'',
        Orari__c:'',

        Tipologia__c:'',
        Ubicazione__c:'',
        Contratto__c:'',
        Competitors__c:'',
        Description:''

      }

    };
  },
  mounted: function() {
    this.recordId=this.$route.params.id;
    this.record=this.$route.params.record;
    this.setupHeaderFields();
    this.setupQueryFields();
    var self=this;
    this.getRecord().then(function() {
      self.getTimeline();
      self.editAccount();
      self.showRecord=true;
    })
  },
  methods: {
/*
['Codice', 'Descrizione', 'Prezzo medio', '%','Quantità','Totale']
'Codice_Item__c', 'Descrizione_Item__c', 'avg(Prezzo_vendita__c) Prezzo_vendita__c', 'avg(Sconto__c) Sconto__c','sum(Quantita_ordinata__c) Quantita_ordinata__c','sum(Totale_Riga__c) Totale_Riga__c']"
'Codice_Item__c', 'Descrizione_Item__c', 'Prezzo_vendita__c', 'Sconto__c','Quantita_ordinata__c','Totale_Riga__c']"
'Riga_Ordine__c'"
'ordine__r.Account__c=\''+id+'\' and ID_Campagna__c=\''+tipocampagna+'\' and FCP_COPYCMSYEAR__c=\''+annocampagna+'\' '"
' Codice_Item__c,  Descrizione_Item__c '"
'Descrizione_Item__c'"
*/
    setDati: function(n) {
        this.dati[n]=this.record[n];
    },
    getRecord: function() {
      var self=this;
      this.recordId=this.$route.params.id;
      return new Promise(function(resolve, reject) {
        var soql='select '+self.fieldsstring+' from Account where id=\''+self.recordId+'\' ';
        console.log(soql);
        apiclient.query(self.$store.getters.connection, soql).then(function(data) {
          console.log('records:'+data.length);
          if (data.length>0)
            self.record=data[0];
          self.updateRecordFields();
          resolve();
        }).catch(function(err){
          console.log(err);
          reject();
        })
      })
    },
    actionClick: function(e) {
      console.log(e);
      switch (e) {
        case 'newtask':
          this.editTask=true;
        break;
        case 'qualifica':
          this.editAccount();
          this.showQualifica=true;            
        break;
      }    
    },
    saveTask: function(event) {
      console.log(event);
      var body={ WhatId: this.recordId, Subject: event.Tipo, Causale__c: event.Causale, Description: event.Descrizione, Utente__c: this.$store.state.user.email, Status: 'Completata', ActivityDate: new Date() };
      var self=this;
      apiclient.newTask(this.$store.getters.connection, body).then(function() {
        self.editTask=false;
        self.getTimeline();
      }).catch(function() {
        self.editTask=false;
      })
    },
    fixObject: function() {
      var fok=[
        "Insegna__c",
        "Referente__c",
        "Phone",
        "Fax",
        "Email__c",
        "Referente_Consegne__c",
        "Orari__c",
        "Tipologia__c",
        "Ubicazione__c",
        "Competitors__c",
        "Description"
      ];
      var o={};
      for (var f in this.dati) {
        if (this.dati[f] && fok.indexOf(f)>=0) o[f]=this.dati[f];
      }
      return o;
    },
    updateAccount: function() {
      console.log('updateAccount')
      var mydata=this.fixObject();
      mydata.Data_Ultima_Modifica_da_Utente__c=new moment().format('YYYY-MM-DD')
      mydata.Utente__c=this.$store.state.user.email;
      //mydata.Id=this.recordId;
      console.log(mydata);
      this.busy=true;
      var self=this;
      apiclient.update(this.$store.getters.connection, 'Account', this.recordId, mydata).then(function(data) {
        self.showQualifica=false;
        self.busy=false;
        console.log(data);
      }).catch(function(err){
        self.showQualifica=false;
        self.busy=false;
        console.log(err);
      })
      
    },
    editAccount: function() {
      this.setDati('Name');
      this.setDati('Codice_2019__c');
      this.setDati('CompanyIdHubspot__c');
      this.setDati('Codice_Subentro__c');
      this.setDati('Insegna__c');

      this.setDati('BillingStreet');
      this.setDati('BillingCity');
      this.setDati('BillingPostalcode');
      this.setDati('BillingState');

      this.setDati('Referente__c');
      this.setDati('Phone');
      this.setDati('Fax');
      this.setDati('Email__c');

      this.setDati('P_Iva__c');
      this.setDati('IBAN__c');
      this.setDati('Codice_Fatturazione_Elettronica__c');
      this.setDati('PEC__c');

      this.setDati('Spedire__c');

      this.setDati('ShippingStreet');
      this.setDati('ShippingCity');
      this.setDati('ShippingPostalcode');
      this.setDati('ShippingState');

      this.setDati('Referente_Consegne__c');
      this.setDati('Orari__c');

      this.setDati('Tipologia__c');
      this.setDati('Ubicazione__c');
      this.setDati('Contratto__c');
      this.setDati('Competitors__c');
      this.setDati('Description');

    },
    setField: function(e) {
      console.log(e)
      var n=e.name;
      var v=e.value;
      var n2=n.substr(n.indexOf(".")+1)
      this.dati[n2]=v;
    },
    updateRecordFields: function() {
      // header
      this.updateFieldsValue(this.headlineFields);
      // record
      this.sections.forEach(function(s) {
        this.updateFieldsValue(s.fields);
      }, this);
    },
    setupQueryFields: function() {
      var mfields=new Map();

      // id e name sempre
      mfields.set('Id', null);
      mfields.set('Name', null);
      mfields.set('Codice_2019__c', null);
      mfields.set('CompanyIdHubspot__c', null);
      mfields.set('Codice_Subentro__c', null);
      mfields.set('Insegna__c', null);

      mfields.set('BillingStreet', null);
      mfields.set('BillingCity', null);
      mfields.set('BillingPostalcode', null);
      mfields.set('BillingState', null);

      mfields.set('Referente__c', null);
      mfields.set('Phone', null);
      mfields.set('Fax', null);
      mfields.set('Email__c', null);

      mfields.set('P_Iva__c', null);
      mfields.set('IBAN__c', null);
      mfields.set('Codice_Fatturazione_Elettronica__c', null);
      mfields.set('PEC__c', null);

      mfields.set('Spedire__c', null);

      mfields.set('ShippingStreet', null);
      mfields.set('ShippingCity', null);
      mfields.set('ShippingPostalcode', null);
      mfields.set('ShippingState', null);

      mfields.set('Referente_Consegne__c', null);
      mfields.set('Orari__c', null);

      mfields.set('Tipologia__c', null);
      mfields.set('Ubicazione__c', null);
      mfields.set('Contratto__c', null);
      mfields.set('Competitors__c', null);
      mfields.set('Description', null);
      
      // header
      this.mapFields(mfields, this.headlineFields);
      // record
      this.sections.forEach(function(s) {
        this.mapFields(mfields, s.fields);
      },this);
      // riassume
      this.fields=this.uniqueFields(mfields);
      this.fieldsstring=this.fields.join(',');
    },
    setupHeaderFields: function() {
      this.headlineFields.push( { value:'', label:'Telefono', name:'Phone', type:'string' } );
      this.headlineFields.push( { value:'', label:'Email', name:'Email__c', type:'string'} );
      this.headlineFields.push( { value:'', label:'Alert', name:'alert__c', type:'alert' } );
    },
    getTimeline: function() {
      var self=this;
      var soql='select Id, Subject, ActivityDate, Description, Utente__c, Type from Task where whatId=\''+this.recordId+'\' order by ActivityDate desc';
      console.log(soql);
      apiclient.query(this.$store.getters.connection, soql).then(function(data) {
        console.log('records:'+data.length);
        data.forEach(function(d) { d.show=false; });
        self.timeline=data;
      }).catch(function(err){
        console.log(err);
      })
    },
  }
}
</script>
